import { Alert } from '@mui/material';

import {
  CustomTextArea,
  CustomTextField,
  DrawerFormSection,
} from '../../../../common/components';
import {
  COST_AREA_OPTIONS,
  COST_BEHAVIOR_OPTIONS,
  COST_TRACEABILITY_OPTIONS,
} from '../../constants/supplierLedgerConstants';
import { FieldSelect, invoiceFieldSpan } from '../SupplierLedgerShared';
import PaymentOrderProviderHeader from './PaymentOrderProviderHeader';

const PaymentOrderDataSection = ({ controller }) => {
  const {
    activeProviderMixedClassificationGroups,
    activeProviderOrderGroups,
    form,
    handleChange,
    handleOrderClassificationChange,
  } = controller;

  return (
    <>
      <PaymentOrderProviderHeader controller={controller} />
      <DrawerFormSection title="Datos de la orden">
        <CustomTextField
          label="Fecha"
          type="date"
          name="emission_date"
          value={form.emission_date}
          onChange={handleChange}
          shrinkLabel
          sx={invoiceFieldSpan(4, 2)}
        />
        <CustomTextArea
          label="Observaciones"
          name="observations"
          value={form.observations}
          onChange={handleChange}
          minRows={3}
          maxRows={5}
          sx={invoiceFieldSpan(8, 2)}
        />
      </DrawerFormSection>
      {activeProviderMixedClassificationGroups.map(({ group, classification }) => (
        <DrawerFormSection
          key={group.id}
          title={activeProviderOrderGroups.length > 1 ? `Clasificación de la orden (${group.currency})` : 'Clasificación de la orden'}
        >
          <Alert severity="info" sx={{ gridColumn: '1 / -1' }}>
            Las facturas incluidas tienen importes con clasificaciones distintas. Elegí la clasificación que van a llevar la orden de pago y sus movimientos.
          </Alert>
          <FieldSelect
            label="Fijo/Variable"
            name={`order-cost-behavior-${group.id}`}
            value={classification.cost_behavior}
            onChange={(event) => handleOrderClassificationChange(group.id, 'cost_behavior', event.target.value)}
            options={COST_BEHAVIOR_OPTIONS}
            sx={invoiceFieldSpan(4)}
          />
          <FieldSelect
            label="Ordinario/Extraordinario"
            name={`order-cost-nature-${group.id}`}
            value={classification.cost_nature}
            onChange={(event) => handleOrderClassificationChange(group.id, 'cost_nature', event.target.value)}
            options={COST_TRACEABILITY_OPTIONS}
            sx={invoiceFieldSpan(4)}
          />
          <FieldSelect
            label="Área"
            name={`order-cost-area-${group.id}`}
            value={classification.cost_area}
            onChange={(event) => handleOrderClassificationChange(group.id, 'cost_area', event.target.value)}
            options={COST_AREA_OPTIONS}
            sx={invoiceFieldSpan(4)}
          />
        </DrawerFormSection>
      ))}
    </>
  );
};

export default PaymentOrderDataSection;
